import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { HBox } from '../Box';
import { Check } from '../Icon';

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: start;
  .notification-block {
    z-index: 9099999;
    position: fixed;
    top: 0;
    right: 0;
    width: ${props => (props.width ? props.width : '450px')};
    height: 73px;
    padding: 10px;
    opacity: 1;
    background-color: #00BFAE;
    color: #fff;
    border-radius: 5px;

    font-size: 18px;
  }

  .icon-block {
    font-size: 24px;
  }
`;

export function Notification(props) {
  return (
    <Container>
      <HBox vCenter left width={props.width} className="notification-block">
        <div className="icon-block">
          <Check />
        </div>
        {props.children}
      </HBox>
    </Container>
  );
}
